/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';

// #endregion Local Imports

const pathname = '/entity-sections';

export const EntitySectionApi = {
  filter: async (option: FilterEntitySectionOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filterForSelect: async (option: FilterEntitySectionOptions) => {
    let url = `${pathname}/filter-for-select`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkExistEntitySections: async (
    entityIDs: string[],
    entitySectionIDs: string[]
  ) => {
    const url = `${pathname}/check-exist-entity-section`;

    try {
      const response = await entityService.post(url, {
        entityIDs,
        entitySectionIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  syncEntitySectionsInChain: async (body: any) => {
    const url = `${pathname}/sync-entity-section`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findDiaryListFromEntitySection: async (id: string) => {
    try {
      const response = await entityService.get(
        `${pathname}/${id}/entity-diaries`
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntitySectionByProductObjectID: async (id: string) => {
    try {
      const response = await entityService.get(
        `${pathname}/find-future-section/${id}`
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  findInheritEntitySection: async (
    option: FindEntitySectionForInheritQuery
  ) => {
    let url = `${pathname}/find-inherit-entity-section`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createGenerateSectionList: async (id: string, body: any) => {
    const url = `${pathname}/generate-list-entity-section/${id}`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  duplicate: async (body: DuplicateOptions) => {
    try {
      const response = await entityService.post(`${pathname}/duplicate`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createReuseDiary: async (body: any) => {
    try {
      const response = await entityService.post(
        `${pathname}/create-reuse-diary`,
        body
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterEntitySectionOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityProductObjectID?: string;
  status?: number;
}

export interface DuplicateOptions {
  id: string;
  name?: string;
  isReuseDiary?: boolean;
  isKeepStructure?: boolean;
}

export interface SyncEntitySection {
  entities: SyncEntitySectionEntity[];
}

interface SyncEntitySectionEntity {
  id: string;
  entitySectionIDs: string[];
}

export interface FindEntitySectionForInheritQuery {
  name?: string;
  entityID?: string;
  entitySectionID?: string;
}
